export default "static/src/images/docinti/thomann.jpg";